import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

class RoofStructureService extends BaseCollectionService {
  constructor() {
    super("roofStructureOptions");
  }

  public async deleteBulkRoofStructures(_ids: string[]) {
    const path = `roofStructures-bulk`;
    return await this.request(
      {
        method: "delete",
        url: path,
        data: { _ids }
      },
      { useToken: "access" }
    );
  }

  async deleteBulk(roofStructureIds: string[]): Promise<ResponseWrapper> {
    const path = `roofStructures/bulk-delete`;
    return await this.request(
      { method: "put", url: path, data: { roofStructureIds } },
      { useToken: "access" }
    );
  }

  async restoreBulk(roofStructureIds: string[]): Promise<ResponseWrapper> {
    const path = `roofStructures/bulk-restore`;
    return await this.request(
      { method: "put", url: path, data: { roofStructureIds } },
      { useToken: "access" }
    );
  }
}

export default new RoofStructureService();
